module.exports = __webpack_public_path__ + "heartTrue.ac0a1730.png";